import {START, SUCCESS, FAIL} from "../constants";

export default store => next => action => {
  const {isCallAPIData, callAPIData, callAPI, type, ...rest} = action;
  if (!callAPI) return next(action);

  next({
    ...rest, type: type + START
  });

  function getFetchData(callAPIData) {
    let json = JSON.stringify(callAPIData)
    return {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: json
    };
  }

  const fetchData = isCallAPIData ? getFetchData(callAPIData) : null;

  // setTimeout(()=> {
    fetch(callAPI, fetchData)
      .then(res => res.json())
      .then(response => {
        next({...rest, type: type + SUCCESS, response})
      })
      .catch(error => ({...rest, type: type + FAIL, error}))
  // }, 200)
}


// WEBPACK FOOTER //
// ./src/middlewares/api.js